<script lang="ts" setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { useRoute } from 'vue-router';
import type { SubscriptionTypeEnum } from '@/api';

const { t } = useI18n();
const route = useRoute();

const confirmedSubscription = computed<SubscriptionTypeEnum | null>(() => {
  const value = route.query.subscription_confirmed;
  if (value !== 'Newsletters' && value !== 'NewListingAlerts') {
    return null;
  }

  return value;
});

const subscriptionName = computed(() => (confirmedSubscription.value ? t(`views.profile.confirmation-banner.subscriptions.${confirmedSubscription.value}`) : ''));
</script>

<template>
  <div v-if="confirmedSubscription" class="border-ph-green-200 bg-ph-green-50 text-ph-green-950 mb-6 rounded-md border-2 px-4 py-3" role="status" aria-live="polite">
    {{ t('views.profile.confirmation-banner.message', { subscription: subscriptionName }) }}
  </div>
</template>
